var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _rect, _g, _defs, _rect2, _g2, _defs2, _rect3, _g3, _defs3, _rect4, _g4, _defs4, _symbol9, _symbol0, _symbol1, _symbol10, _rect5, _g5, _rect6, _g6, _rect7, _g7, _rect8, _g8, _rect9, _g9, _rect0, _g0, _rect1, _g1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunctionalIconsSprite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "Check",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2889_8220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.025 3.07048L9.03004 11.0655C8.83454 11.261 8.51804 11.261 8.32304 11.0655L4.30838 7.05082C4.11288 6.85532 3.79638 6.85532 3.60138 7.05082L1.47988 9.17232C1.28438 9.36782 1.28438 9.68432 1.47988 9.87932L8.32304 16.7225C8.51854 16.918 8.83504 16.918 9.03004 16.7225L19.8535 5.89898C20.049 5.70348 20.049 5.38698 19.8535 5.19198L17.732 3.07048C17.537 2.87498 17.2205 2.87498 17.025 3.07048Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2889_8220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  }))))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "Question mark",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.394 14.3358H8.35216C8.04798 14.3358 7.84519 14.1353 7.84519 13.8346V9.97494C7.84519 9.67419 8.04798 9.47368 8.35216 9.47368H9.87307C12.6107 9.47368 12.6107 6.86717 12.6107 6.76692C12.6107 6.66667 12.6107 4.01003 9.87307 4.01003C8.35216 4.01003 7.54101 5.16291 7.18613 5.81454C7.08473 6.01504 6.83125 6.11529 6.57776 6.06516L3.68803 5.11278C3.38385 5.01253 3.28245 4.66165 3.38385 4.41103C4.34709 2.20551 6.67916 0 9.87307 0C14.2837 0 16.6665 3.45865 16.6665 6.71679C16.6665 9.32331 15.1456 12.0802 12.2558 13.0827C12.053 13.1328 11.901 13.3333 11.901 13.5338V13.7845C11.901 14.0852 11.6982 14.3358 11.394 14.3358Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3941 20H8.35231C8.04813 20 7.84534 19.7995 7.84534 19.4988V16.6917C7.84534 16.391 8.04813 16.1905 8.35231 16.1905H11.3941C11.6983 16.1905 11.9011 16.391 11.9011 16.6917V19.4988C11.9011 19.7995 11.6983 20 11.3941 20Z",
    fill: "currentColor"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "Info",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2889_8258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0H11.5C11.8 0 12 0.200501 12 0.501253V3.30827C12 3.60902 11.8 3.80952 11.5 3.80952H8.5C8.2 3.80952 8 3.60902 8 3.30827V0.501253C8 0.200501 8.2 0 8.5 0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 6.9975H11.5C11.8 6.9975 12 7.198 12 7.49875V19.4988C12 19.7995 11.8 20 11.5 20H8.5C8.2 20 8 19.7995 8 19.4988V7.49875C8 7.24812 8.2 6.9975 8.5 6.9975Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2889_8258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 20,
    fill: "currentColor",
    transform: "translate(8)"
  }))))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "Menu",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0312 17H8.96875C8.70987 17 8.5 17.2099 8.5 17.4688V19.5312C8.5 19.7901 8.70987 20 8.96875 20H11.0312C11.2901 20 11.5 19.7901 11.5 19.5312V17.4688C11.5 17.2099 11.2901 17 11.0312 17Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0312 8.5H8.96875C8.70987 8.5 8.5 8.70987 8.5 8.96875V11.0312C8.5 11.2901 8.70987 11.5 8.96875 11.5H11.0312C11.2901 11.5 11.5 11.2901 11.5 11.0312V8.96875C11.5 8.70987 11.2901 8.5 11.0312 8.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0312 0H8.96875C8.70987 0 8.5 0.209867 8.5 0.46875V2.53125C8.5 2.79013 8.70987 3 8.96875 3H11.0312C11.2901 3 11.5 2.79013 11.5 2.53125V0.46875C11.5 0.209867 11.2901 0 11.0312 0Z",
    fill: "currentColor"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "Simple arrow-Direction=Up",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2889_8366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.90181 12.5901C1.81916 12.6689 1.81916 12.8008 1.90181 12.8796L3.07636 13.9995C3.15362 14.0732 3.27512 14.0732 3.35239 13.9995L9.86199 7.79274C9.93925 7.71907 10.0608 7.71907 10.138 7.79274L16.6476 13.9995C16.7249 14.0732 16.8464 14.0732 16.9236 13.9995L18.0982 12.8796C18.1808 12.8008 18.1808 12.6689 18.0982 12.5901L10.138 5.00023C10.0608 4.92656 9.93925 4.92656 9.86199 5.00023L1.90181 12.5901Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2889_8366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  }))))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "Simple arrow-Direction=Down",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2889_8367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0982 7.40987C18.1808 7.33107 18.1808 7.19918 18.0982 7.12038L16.9236 6.00046C16.8464 5.92679 16.7249 5.92679 16.6476 6.00046L10.138 12.2073C10.0608 12.2809 9.93925 12.2809 9.86199 12.2073L3.35239 6.00046C3.27513 5.92679 3.15362 5.92679 3.07636 6.00046L1.90181 7.12038C1.81916 7.19918 1.81916 7.33107 1.90181 7.40987L9.86199 14.9998C9.93925 15.0734 10.0608 15.0734 10.138 14.9998L18.0982 7.40987Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2889_8367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  }))))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "Simple arrow-Direction=Left",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2889_8368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5901 18.0982C12.6689 18.1809 12.8008 18.1809 12.8796 18.0982L13.9995 16.9237C14.0732 16.8464 14.0732 16.7249 13.9995 16.6476L7.79271 10.138C7.71904 10.0608 7.71904 9.93928 7.79271 9.86202L13.9995 3.35242C14.0732 3.27516 14.0732 3.15365 13.9995 3.07639L12.8796 1.90184C12.8008 1.81919 12.6689 1.81919 12.5901 1.90184L5.0002 9.86202C4.92653 9.93928 4.92653 10.0608 5.0002 10.138L12.5901 18.0982Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2889_8368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  }))))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "Simple arrow-Direction=Right",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.4099 1.90178C7.3311 1.81913 7.19921 1.81913 7.12041 1.90178L6.00049 3.07633C5.92682 3.15359 5.92682 3.27509 6.00049 3.35236L12.2073 9.86196C12.281 9.93922 12.281 10.0607 12.2073 10.138L6.00049 16.6476C5.92682 16.7248 5.92682 16.8463 6.00049 16.9236L7.12041 18.0982C7.19921 18.1808 7.3311 18.1808 7.4099 18.0982L14.9998 10.138C15.0735 10.0607 15.0735 9.93922 14.9998 9.86195L7.4099 1.90178Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "Pointer arrow-Direction=Up",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2908_8247)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2908_8247",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2908_8247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8208 8.15354C14.9197 8.25238 14.9183 8.41307 14.8177 8.51017L13.9691 9.32948C13.871 9.4242 13.7151 9.42283 13.6187 9.32641L10.8341 6.54178L10.8341 16.4446C10.8341 16.5673 10.7346 16.6668 10.6118 16.6668H9.4174C9.27933 16.6668 9.1674 16.5548 9.1674 16.4168L9.1674 6.54178L6.38277 9.32641C6.28635 9.42283 6.13044 9.4242 6.03234 9.32948L5.18377 8.51017C5.0832 8.41307 5.08179 8.25238 5.18064 8.15354L9.82396 3.51022C9.92159 3.41259 10.0799 3.41259 10.1775 3.51022L14.8208 8.15354Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2908_8247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  }))))), /*#__PURE__*/React.createElement("symbol", {
    id: "Pointer arrow-Direction=Down",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2908_8248)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2908_8248",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2908_8248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.18076 11.8466C5.08192 11.7477 5.08333 11.5871 5.18389 11.49L6.03246 10.6706C6.13056 10.5759 6.28647 10.5773 6.38289 10.6737L9.16752 13.4583L9.16752 3.55557C9.16752 3.43284 9.26701 3.33334 9.38974 3.33334L10.5842 3.33334C10.7223 3.33334 10.8342 3.44527 10.8342 3.58334L10.8342 13.4583L13.6188 10.6737C13.7152 10.5773 13.8711 10.5759 13.9692 10.6706L14.8178 11.49C14.9184 11.5871 14.9198 11.7477 14.8209 11.8466L10.1776 16.4899C10.08 16.5875 9.92171 16.5875 9.82408 16.4899L5.18076 11.8466Z",
    fill: "currentColor"
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2908_8248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  }))))), /*#__PURE__*/React.createElement("symbol", {
    id: "Pointer arrow-Direction=Left",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2908_8249)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2908_8249",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2908_8249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.15424 5.18006C8.25309 5.08121 8.41377 5.08262 8.51087 5.18319L9.33018 6.03176C9.4249 6.12986 9.42353 6.28577 9.32711 6.38219L6.54248 9.16682L16.4453 9.16682C16.568 9.16682 16.6675 9.26631 16.6675 9.38904V10.5835C16.6675 10.7216 16.5556 10.8335 16.4175 10.8335L6.54248 10.8335L9.32711 13.6181C9.42353 13.7145 9.4249 13.8704 9.33018 13.9685L8.51087 14.8171C8.41377 14.9177 8.25309 14.9191 8.15424 14.8202L3.51092 10.1769C3.41329 10.0793 3.41329 9.92101 3.51092 9.82338L8.15424 5.18006Z",
    fill: "currentColor"
  })))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2908_8249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  }))))), /*#__PURE__*/React.createElement("symbol", {
    id: "Pointer arrow-Direction=Right",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2908_8250)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2908_8250",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2908_8250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8475 14.8202C11.7486 14.9191 11.5879 14.9177 11.4908 14.8171L10.6715 13.9685C10.5768 13.8704 10.5782 13.7145 10.6746 13.6181L13.4592 10.8335H3.55645C3.43372 10.8335 3.33423 10.734 3.33423 10.6113V9.41682C3.33423 9.27875 3.44616 9.16682 3.58423 9.16682H13.4592L10.6746 6.38219C10.5782 6.28577 10.5768 6.12986 10.6715 6.03176L11.4908 5.18319C11.5879 5.08262 11.7486 5.08121 11.8475 5.18006L16.4908 9.82338C16.5884 9.92101 16.5884 10.0793 16.4908 10.1769L11.8475 14.8202Z",
    fill: "currentColor"
  })))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2908_8250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  }))))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "Close",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.11744 18.3232C3.0198 18.4209 2.86151 18.4209 2.76388 18.3232L1.67678 17.2361C1.57915 17.1385 1.57915 16.9802 1.67678 16.8826L8.38257 10.1768C8.4802 10.0791 8.4802 9.92086 8.38257 9.82322L1.67678 3.11744C1.57915 3.01981 1.57915 2.86151 1.67678 2.76388L2.76388 1.67678C2.86151 1.57915 3.0198 1.57915 3.11744 1.67678L9.82322 8.38256C9.92086 8.4802 10.0791 8.4802 10.1768 8.38256L16.8826 1.67678C16.9802 1.57915 17.1385 1.57915 17.2361 1.67678L18.3232 2.76388C18.4209 2.86151 18.4209 3.01981 18.3232 3.11744L11.6174 9.82322C11.5198 9.92086 11.5198 10.0791 11.6174 10.1768L18.3232 16.8826C18.4209 16.9802 18.4209 17.1385 18.3232 17.2361L17.2361 18.3232C17.1385 18.4209 16.9802 18.4209 16.8826 18.3232L10.1768 11.6174C10.0791 11.5198 9.92086 11.5198 9.82322 11.6174L3.11744 18.3232Z",
    fill: "currentColor"
  }))), _symbol0 || (_symbol0 = /*#__PURE__*/React.createElement("symbol", {
    id: "Minus",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 11,
    width: 2,
    height: 15,
    rx: 0.2,
    transform: "rotate(-90 2.5 11)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 9,
    width: 15,
    height: 2,
    rx: 0.4,
    fill: "currentColor"
  }))), _symbol1 || (_symbol1 = /*#__PURE__*/React.createElement("symbol", {
    id: "Plus",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.4 17C9.17909 17 9 16.8209 9 16.6V11H3.4C3.17909 11 3 10.8209 3 10.6V9.4C3 9.17909 3.17909 9 3.4 9H9V3.4C9 3.17909 9.17909 3 9.4 3H10.6C10.8209 3 11 3.17909 11 3.4V9H16.6C16.8209 9 17 9.17909 17 9.4V10.6C17 10.8209 16.8209 11 16.6 11H11V16.6C11 16.8209 10.8209 17 10.6 17H9.4Z",
    fill: "currentColor"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "Equals",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.15 13.75C3.92909 13.75 3.75 13.5709 3.75 13.35V12.0667C3.75 11.8458 3.92909 11.6667 4.15 11.6667H15.85C16.0709 11.6667 16.25 11.8458 16.25 12.0667V13.35C16.25 13.5709 16.0709 13.75 15.85 13.75H4.15ZM4.15 8.33334C3.92909 8.33334 3.75 8.15426 3.75 7.93334V6.65003C3.75 6.42912 3.92909 6.25003 4.15 6.25003H15.85C16.0709 6.25003 16.25 6.42912 16.25 6.65003V7.93334C16.25 8.15426 16.0709 8.33334 15.85 8.33334H4.15Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "Fast-forward",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3029_10798",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 0.25,
    fill: "currentColor"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3029_10798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.47205 14.7409C2.30591 14.8516 2.08337 14.7325 2.08337 14.5329V5.46713C2.08337 5.26745 2.30591 5.14836 2.47205 5.25912L9.27136 9.79199C9.41979 9.89094 9.41979 10.1091 9.27136 10.208L2.47205 14.7409ZM10.8054 14.7409C10.6392 14.8516 10.4167 14.7325 10.4167 14.5329V5.46713C10.4167 5.26745 10.6392 5.14836 10.8054 5.25912L17.6047 9.79199C17.7531 9.89094 17.7531 10.1091 17.6047 10.208L10.8054 14.7409Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "Play",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3029_10799",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3029_10799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.47374 15.4258C6.19635 15.6023 5.83337 15.4031 5.83337 15.0743V4.92569C5.83337 4.5969 6.19635 4.39764 6.47374 4.57416L14.4476 9.64846C14.7049 9.8122 14.7049 10.1878 14.4476 10.3515L6.47374 15.4258Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "Fast-rewind",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3029_10800",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 0.25,
    fill: "currentColor"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3029_10800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9167 14.5329C17.9167 14.7325 17.6942 14.8516 17.528 14.7409L10.7287 10.208C10.5803 10.1091 10.5803 9.89094 10.7287 9.79199L17.528 5.25912C17.6942 5.14836 17.9167 5.26746 17.9167 5.46713V14.5329ZM9.58337 14.5329C9.58337 14.7325 9.36084 14.8516 9.1947 14.7409L2.39539 10.208C2.24696 10.1091 2.24696 9.89094 2.39539 9.79199L9.1947 5.25912C9.36084 5.14836 9.58337 5.26746 9.58337 5.46713V14.5329Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "Forward-10",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3029_10801",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3029_10801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.3333V9.58334H6.25V8.33334H8.75V13.3333H7.5ZM10.4167 13.3333C10.1806 13.3333 9.98264 13.2535 9.82292 13.0938C9.66319 12.934 9.58333 12.7361 9.58333 12.5V9.16668C9.58333 8.93057 9.66319 8.73265 9.82292 8.57293C9.98264 8.4132 10.1806 8.33334 10.4167 8.33334H12.0833C12.3194 8.33334 12.5174 8.4132 12.6771 8.57293C12.8368 8.73265 12.9167 8.93057 12.9167 9.16668V12.5C12.9167 12.7361 12.8368 12.934 12.6771 13.0938C12.5174 13.2535 12.3194 13.3333 12.0833 13.3333H10.4167ZM10.8333 12.0833H11.6667V9.58334H10.8333V12.0833ZM10 18.3333C8.95833 18.3333 7.98264 18.1354 7.07292 17.7396C6.16319 17.3438 5.37153 16.809 4.69792 16.1354C4.02431 15.4618 3.48958 14.6701 3.09375 13.7604C2.69792 12.8507 2.5 11.875 2.5 10.8333C2.5 9.79168 2.69792 8.81598 3.09375 7.90626C3.48958 6.99654 4.02431 6.20487 4.69792 5.53126C5.37153 4.85765 6.16319 4.32293 7.07292 3.92709C7.98264 3.53126 8.95833 3.33334 10 3.33334H10.125L9.00704 2.21538C8.91061 2.11896 8.90925 1.96305 9.00396 1.86495L9.82328 1.01638C9.92037 0.915814 10.0811 0.914404 10.1799 1.01325L13.1566 3.9899C13.2542 4.08753 13.2542 4.24582 13.1566 4.34345L10.1799 7.3201C10.0811 7.41895 9.92037 7.41754 9.82328 7.31698L9.00396 6.4684C8.90925 6.3703 8.91061 6.2144 9.00704 6.11797L10.125 5.00001H10C8.375 5.00001 6.99653 5.56598 5.86458 6.69793C4.73264 7.82987 4.16667 9.20834 4.16667 10.8333C4.16667 12.4583 4.73264 13.8368 5.86458 14.9688C6.99653 16.1007 8.375 16.6667 10 16.6667C11.625 16.6667 13.0035 16.1007 14.1354 14.9688C15.2088 13.8953 15.7733 12.6002 15.8288 11.0834C15.8338 10.9455 15.9453 10.8333 16.0833 10.8333H17.25C17.3881 10.8333 17.5004 10.9453 17.4962 11.0833C17.4669 12.0315 17.2703 12.9239 16.9062 13.7604C16.5104 14.6701 15.9757 15.4618 15.3021 16.1354C14.6285 16.809 13.8368 17.3438 12.9271 17.7396C12.0174 18.1354 11.0417 18.3333 10 18.3333Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "Replay-10",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3029_10802",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3029_10802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 18.3333C8.95833 18.3333 7.98264 18.1354 7.07292 17.7396C6.16319 17.3437 5.37153 16.809 4.69792 16.1354C4.02431 15.4618 3.48958 14.6701 3.09375 13.7604C2.72975 12.9238 2.53311 12.0315 2.50384 11.0833C2.49958 10.9453 2.61193 10.8333 2.75 10.8333H3.91667C4.05474 10.8333 4.16616 10.9454 4.17121 11.0834C4.22671 12.6002 4.79117 13.8953 5.86458 14.9687C6.99653 16.1007 8.375 16.6666 10 16.6666C11.625 16.6666 13.0035 16.1007 14.1354 14.9687C15.2674 13.8368 15.8333 12.4583 15.8333 10.8333C15.8333 9.20831 15.2674 7.82984 14.1354 6.6979C13.0035 5.56595 11.625 4.99998 10 4.99998H9.875L10.993 6.11794C11.0894 6.21437 11.0908 6.37027 10.996 6.46837L10 7.49998L6.84344 4.34342C6.74581 4.24579 6.74581 4.0875 6.84344 3.98987L9.82009 1.01322C9.91894 0.914374 10.0796 0.915783 10.1767 1.01635L10.996 1.86492C11.0908 1.96302 11.0894 2.11893 10.993 2.21535L9.875 3.33331H10C11.0417 3.33331 12.0174 3.53123 12.9271 3.92706C13.8368 4.3229 14.6285 4.85762 15.3021 5.53123C15.9757 6.20484 16.5104 6.99651 16.9062 7.90623C17.3021 8.81595 17.5 9.79165 17.5 10.8333C17.5 11.875 17.3021 12.8507 16.9062 13.7604C16.5104 14.6701 15.9757 15.4618 15.3021 16.1354C14.6285 16.809 13.8368 17.3437 12.9271 17.7396C12.0174 18.1354 11.0417 18.3333 10 18.3333ZM7.5 13.3333V9.58331H6.25V8.33331H8.75V13.3333H7.5ZM10.4167 13.3333C10.1806 13.3333 9.98264 13.2535 9.82292 13.0937C9.66319 12.934 9.58333 12.7361 9.58333 12.5V9.16665C9.58333 8.93053 9.66319 8.73262 9.82292 8.5729C9.98264 8.41317 10.1806 8.33331 10.4167 8.33331H12.0833C12.3194 8.33331 12.5174 8.41317 12.6771 8.5729C12.8368 8.73262 12.9167 8.93053 12.9167 9.16665V12.5C12.9167 12.7361 12.8368 12.934 12.6771 13.0937C12.5174 13.2535 12.3194 13.3333 12.0833 13.3333H10.4167ZM10.8333 12.0833H11.6667V9.58331H10.8333V12.0833Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "Pause",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3033_11011",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3033_11011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9167 15.8333C11.7786 15.8333 11.6667 15.7214 11.6667 15.5833V4.41666C11.6667 4.27859 11.7786 4.16666 11.9167 4.16666H14.75C14.8881 4.16666 15 4.27859 15 4.41666V15.5833C15 15.7214 14.8881 15.8333 14.75 15.8333H11.9167ZM5.25 15.8333C5.11193 15.8333 5 15.7214 5 15.5833V4.41666C5 4.27859 5.11193 4.16666 5.25 4.16666H8.08333C8.2214 4.16666 8.33333 4.27859 8.33333 4.41666V15.5833C8.33333 15.7214 8.2214 15.8333 8.08333 15.8333H5.25Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "Edit",
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3747_738",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3747_738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 15.8333H5.35417L13.5 7.6875L12.3125 6.5L4.16667 14.6458V15.8333ZM2.5 17.5V13.9583L13.5 2.97917C13.6667 2.82639 13.8507 2.70833 14.0521 2.625C14.2535 2.54167 14.4653 2.5 14.6875 2.5C14.9097 2.5 15.125 2.54167 15.3333 2.625C15.5417 2.70833 15.7222 2.83333 15.875 3L17.0208 4.16667C17.1875 4.31944 17.309 4.5 17.3854 4.70833C17.4618 4.91667 17.5 5.125 17.5 5.33333C17.5 5.55556 17.4618 5.76736 17.3854 5.96875C17.309 6.17014 17.1875 6.35417 17.0208 6.52083L6.04167 17.5H2.5ZM12.8958 7.10417L12.3125 6.5L13.5 7.6875L12.8958 7.10417Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunctionalIconsSprite);
export default __webpack_public_path__ + "static/media/functional-icons-sprite.420b9df84d5b62e61671f639281f667a.svg";
export { ForwardRef as ReactComponent };